<template>
  <div>
    <button class="btn green margin-bottom-10" @click="showAddFormModal = true">Add New</button>
    <base-form-index
      v-if="!loading"
      :loading="loading"
      :rows="rows"
      :columns="columns"
      :is-template="true"
      @form-removed="fetchFormsTemplates"
    />

    <add-form-modal v-if="showAddFormModal"
                    v-on:hide="showAddFormModal = false"
                    :is-template="true"
                    :modules="[]"/>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import BaseFormIndex from "./BaseFormIndex";
import AddFormModal from "@/components/formbuilder/modals/AddFormModal";

export default {

  components: {
    AddFormModal,
    BaseFormIndex
  },
  data() {
    return {
      showAddFormModal: false,
      formPublish: true,
      formAccounts: [],
      columns: [
        {
          label: 'Name',
          field: 'name',
          html: true,
          filterOptions: {enabled: true}
        },
        {
          label: 'Description',
          field: 'description',
          filterOptions: {enabled: true}
        },
        {
          label: 'Created By',
          field: 'created_date',
          filterOptions: {enabled: true}
        },
        {
          label: 'Last Modified',
          field: 'last_modification_date',
          filterOptions: {enabled: true}
        },
        {
          label: 'Actions',
          field: 'actions',
          sortable: false,
        }
      ],
    }
  },

  computed: {
    ...mapGetters({
      appUser: 'getUser',
      templates: 'getFormsTemplates',
      loading: 'getFormsTemplatesLoading'
    }),

    rows() {
      let rows = [];
      Object.entries(this.templates).forEach(([key, row]) => {

        let date = this.$options.filters.formatDate(row.created_date.date);
        row.created_date = row.user + ' on ' + date;

        if (row.last_modification_date) {
          date = this.$options.filters.formatDate(row.last_modification_date);
        }

        if (row.last_action_user) {
          row.last_modification_date = row.last_action_user + ' on ' + date;
        }
        rows.push(row);
      });
      return rows;
    }
  },

  mounted() {
    this.fetchFormsTemplates();
  },

  methods: {
    ...mapActions([
      'fetchFormsTemplates'
    ]),
  },
}
</script>

<style scoped>
.last-dropdown {
  width: auto;
}

.dropdown-menu {
  left: -110px;
}

.dropdown > .dropdown-menu:before, .dropdown-toggle > .dropdown-menu:before, .btn-group > .dropdown-menu:before {
  left: 140px;
}

.btn-group > .dropdown-menu:after {
  left: 141px;
}
</style>



// WEBPACK FOOTER //
// TemplatesIndex.vue?7e023812